import { useState } from 'react';
import { toast } from 'react-hot-toast';
import { Radar } from 'lucide-react';
import { ScrapeConfigForm } from '../components/ScrapeConfigForm';
import { LiveSession } from '../components/LiveSession';
import { JobHistory } from '../components/JobHistory';
import { useScrapeStream } from '../hooks/useScrapeStream';
import type { ScrapeParams } from '../types';

export function ScraperPage() {
  const stream = useScrapeStream();
  const [lastMax, setLastMax] = useState(20);

  const handleStart = (params: ScrapeParams) => {
    if (stream.isActive) {
      toast.error('A scan is already running.');
      return;
    }
    setLastMax(params.maxResults);
    stream.start(params);
  };

  return (
    <div className="flex h-full flex-col gap-4 p-6">
      <div className="flex items-center gap-3">
        <Radar className="h-6 w-6 text-primary" />
        <div>
          <h1 className="text-display-sm font-semibold text-on-surface">Lead Generation</h1>
          <p className="text-body-sm text-on-surface-variant">Scrape business leads and track every scan.</p>
        </div>
      </div>

      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
        <ScrapeConfigForm disabled={stream.isActive} onStart={handleStart} />
        <LiveSession stream={stream} onStop={stream.stop} maxResults={lastMax} />
      </div>

      <JobHistory />
    </div>
  );
}
